import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { View } from '@olxbr/design-system'

import SvgMultiElements from '../SvgMultiElements'
import mailCheckConfig from '../../../assets/icons/mail-check'

const Wrapper = styled(View)`
  padding-left: 22px;
`

const MailCheck = props => (
  <Wrapper>
    <SvgMultiElements config={{ ...mailCheckConfig, ...props.config }} />
  </Wrapper>
)

MailCheck.propTypes = {
  config: PropTypes.object, // eslint-disable-line
}

export default MailCheck
